'use client';

import { useTranslations } from 'next-intl';
import { FeatureDetailContent } from './FeatureDetailContent';
import {
    Network,
    Users,
    TrendingUp,
    Search,
    Eye,
    BarChart3
} from 'lucide-react';

export function GenealogyTreeContent() {
    const t = useTranslations('genealogyTree');

    const features = [
        {
            icon: Network,
            title: t('features.step1.title'),
            description: t('features.step1.description'),
        },
        {
            icon: Users,
            title: t('features.step2.title'),
            description: t('features.step2.description'),
        },
        {
            icon: TrendingUp,
            title: t('features.step3.title'),
            description: t('features.step3.description'),
        },
        {
            icon: Search,
            title: t('features.step4.title'),
            description: t('features.step4.description'),
        },
        {
            icon: Eye,
            title: t('features.step5.title'),
            description: t('features.step5.description'),
        },
        {
            icon: BarChart3,
            title: t('features.step6.title'),
            description: t('features.step6.description'),
        },
    ];

    // Get benefits list from translations, ensuring it's always an array
    const benefitsRaw = t.raw('benefits.list');
    const benefits = Array.isArray(benefitsRaw) ? benefitsRaw : (benefitsRaw ? [benefitsRaw] : []);

    return (
        <FeatureDetailContent
            pageKey="genealogy-tree"
            translationNamespace="genealogyTree"
            features={features}
            benefits={benefits}
            ctaIcon={Network}
            showWhatIsBitcoin={false}
            introImageSrc="/images/features/Genealogy-tree.webp"
            introImageAlt={t('intro.imageAlt') || 'Genealogy Tree in MLM Software'}
            introParagraphKeys={['paragraph2', 'paragraph3']}
            introSectionHeadingPage="genealogy-tree"
            introSectionHeadingTitle={t('intro.sectionHeadingTitle') || 'About Genealogy Tree'}
            introSectionHeadingPill={t('intro.sectionHeadingPill') || 'Genealogy Tree'}
            useLocaleContent={true}
        />
    );
}

